/*
 * @Author: Chao Yang
 * @Date: 2021-01-10 20:39:12
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-01-10 20:48:38
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IMainMenuItem } from 'src/app/domain/model/info/site/iMain-menu-item.model';
import { BaseProxy } from '../base.proxy';
import { environment } from 'src/environments/environment';

@Injectable()
export class MenuProxy extends BaseProxy {
  constructor(_http: HttpClient) {
    super(_http);
  }

  getMenus(): Observable<IMainMenuItem[]> {
    if (environment.feature.newApi === false) {
      return this._http.get<IMainMenuItem[]>('/ip/api/menu');
    } else {
      return this._http.get<IMainMenuItem[]>('/ip-api/api/menu');
    }
  }

  getInvestmentMenus(mcpDealId: number): Observable<any> {
    if (environment.feature.newApi === false) {
      return this._http.get<any>(`/ip/api/menu?mcpDealId=${mcpDealId}`);
    } else {
      return this._http.get<any>(
        `/ip/api/menu/investment?mcpDealId=${mcpDealId}`
      );
    }
  }
}
